const {
  getMediaCoreAndVerifyDeviceStreamsStatusV2,
  getRecordingAsBlob,
  getFormattedRecordingUrls
} = require('cloud-utils/helpers/recording-stream-helpers')

angular
  .module('surfsightApp.controllers')
  .controller('recordingVideoController', [
    '$rootScope',
    '$scope',
    '$timeout',
    '$interval',
    '$filter',
    '$localStorage',
    function ($rootScope, $scope, $timeout, $interval, $filter, $localStorage) {
      $scope.hoveringVideoElement = false
      $scope.continueVideoElement = false
      $scope.recordingVideoElementToggle = false
      const recordingVideoDuration = 30
      let recordingVideoTrackerTimer
      let mediaToken = $scope.recordingData.mediaToken
      let edgeTime = $scope.recordingData.nearestLocation.time
      const {
        serialNumber,
        streamId,
        recordingStreamQuality
      } = $scope.recordingData
      const videoElementId = `remoteVideos-${serialNumber}-${streamId}`
      $scope.displayOptions = {
        showDisplayOptions: true,
        fullScreen: true,
        playPause: true,
        closeVideo: true,
        ...($scope.recordingData.displayOptions || {})
      }
      const streamName = window.getCameraNameByStreamId(
        $filter('translate'),
        $scope.recordingData.edge,
        streamId
      )
      $scope.recStreamDisplay = {
        serialNumber,
        cameraName: $scope.recordingData.edge.name || serialNumber,
        streamId,
        streamName
      }
      $scope.playerStatus = {
        playStatus: false,
        fullScreen: false
      }
      $scope.videoElementId = videoElementId
      let recordingAbortController
      const initPlayerControls = async () => {
        recordingAbortController && recordingAbortController.abort()
        recordingAbortController = new window.AbortController()
        const url = `${V2_BASEURL}/devices/${serialNumber}/connect-media`

        try {
          const {
            deviceStreamsStatus,
            mediacore,
            token
          } = await getMediaCoreAndVerifyDeviceStreamsStatusV2(
            url,
            serialNumber,
            recordingAbortController,
            {
              'X-Request-Origin': 'White Label Portal',
              'Content-Type': 'application/json',
              Authorization: `Bearer ${$localStorage.userToken}`
            }
          )
          if (!deviceStreamsStatus) {
            throw new Error('Device offline')
          }
          const { videoSrc } = getFormattedRecordingUrls(mediacore, token, {
            serialNumber,
            streamId,
            startTime: edgeTime,
            duration: recordingVideoDuration,
            quality: recordingStreamQuality.value
          })
          if ($rootScope.browserInfo.config.isSafari) {
            const blob = await getRecordingAsBlob(
              videoSrc,
              recordingAbortController
            )
            $scope.recvideoSource = window.URL.createObjectURL(blob)
          } else {
            $scope.recvideoSource = videoSrc
          }
          $scope.recordingVideoElementToggle = true
          $timeout(() => {
            applyRecordingPlaybackSpeed()
            initPlayerTracking()
            playPauseVideo()
          }, 500)
          $scope.$apply()
        } catch (ex) {
          console.log(ex)
          return
        }
      }
      let fullScreenTracker
      const goFullScreen = () => {
        try {
          const element = document.getElementById(`${videoElementId}-container`)
          for (const fullScreenProp of [
            'requestFullscreen',
            'mozRequestFullScreen',
            'webkitRequestFullscreen',
            'webkitEnterFullScreen',
            'msRequestFullscreen'
          ]) {
            if (element[fullScreenProp]) {
              element[fullScreenProp]()
              fullScreenTracker = $interval(() => {
                const currentFullScreenState =
                  document.fullScreen ||
                  document.mozFullScreen ||
                  document.webkitIsFullScreen ||
                  document.webkitFullscreenElement
                if (!currentFullScreenState) {
                  fullScreenTracker && $interval.cancel(fullScreenTracker)
                  fullScreenTracker = null
                  $scope.playerStatus.fullScreen = false
                }
              }, 1000)
            }
          }
        } catch (e) {
          console.error(e)
        }
      }
      const exitFullScreen = () => {
        for (const exitFullScreenProp of [
          'exitFullscreen',
          'mozCancelFullScreen',
          'webkitExitFullscreen',
          'msExitFullscreen'
        ]) {
          if (document[exitFullScreenProp]) {
            document[exitFullScreenProp]()
            break
          }
        }
      }
      const toggleFullScreen = () => {
        const currentFullScreenState =
          document.fullScreen ||
          document.mozFullScreen ||
          document.webkitIsFullScreen ||
          document.webkitFullscreenElement
        if (currentFullScreenState) {
          exitFullScreen()
          $scope.playerStatus.fullScreen = false
        } else {
          goFullScreen()
          $scope.playerStatus.fullScreen = true
        }
      }
      const applyRecordingPlaybackSpeed = () => {
        const element = document.getElementById(videoElementId)
        if (element) {
          element.playbackRate = recordingStreamQuality.playbackRate
        }
      }
      const playPauseVideo = () => {
        if ($scope.continueVideoElement) return continueRecording()
        $scope.continueVideoElement = false
        const element = document.getElementById(videoElementId)
        $scope.playerStatus.playStatus = element.paused
        if (!element.ended) {
          $scope.playerStatus.playStatus ? element.play() : element.pause()
        }
      }
      const continueRecording = () => {
        $scope.continueVideoElement = false
        clearVideoSrc()
        $timeout(() => {
          $scope.recordingVideoElementToggle = false
          edgeTime += recordingVideoDuration // next recording video start time
          initPlayerControls()
        })
      }
      const initPlayerTracking = () => {
        stopPlayerTracking()
        recordingVideoTrackerTimer = $interval(trackPlayerTime, 2000)
      }
      const stopPlayerTracking = () => {
        recordingVideoTrackerTimer &&
          $interval.cancel(recordingVideoTrackerTimer)
      }
      const trackPlayerTime = () => {
        const element = document.getElementById(videoElementId)
        if (!$scope.playerStatus.playStatus) {
          !element.paused && element.pause()
          return
        }
        console.warn(element.currentTime, element.ended)
        if (
          $scope.playerStatus.playStatus &&
          (Math.round(element.currentTime) >= recordingVideoDuration ||
            (Math.round(element.currentTime) >= recordingVideoDuration - 2 &&
              element.ended))
        ) {
          playPauseVideo()
          $scope.continueVideoElement = true // Show continue video message in the player
          stopPlayerTracking()
        }
      }
      const clearVideoSrc = () => {
        const video = document.getElementById(videoElementId)
        if (video) {
          video.src = ''
          video.load()
        }
      }
      $scope.closeRecordingVideo = () => {
        clearVideoSrc()
        $scope.closeVideo($scope.recordingData)
      }
      $scope.toggleFullScreen = toggleFullScreen
      $scope.playPauseVideo = playPauseVideo
      $scope.continueRecording = continueRecording
      $timeout(initPlayerControls, 300)
      // TODO: migrate to v2 - stop renewed media token via /generate_authtoken v1. Invoke again /connect-media v2 after 30 minutes
      // TODO: more: https://documentation.s3.us-east-2.amazonaws.com/v2/index.html#operation/postDeviceConnectMedia
      $scope.$on('updateMediaToken', (e, data) => {
        mediaToken = data.mediaToken // update media token
      })
      $scope.$on('$destroy', function () {
        clearVideoSrc()
        stopPlayerTracking()
        fullScreenTracker && $interval.cancel(fullScreenTracker)
        recordingAbortController && recordingAbortController.abort()
      })
    }
  ])
